import moment from 'moment';

const formatDate = (date, format = 'D MMM YYYY') => {
  if (date) {
    return moment(new Date(`${date} UTC`)).format(format);
  }
  return '';
};

const ago = (dateStr) => {
  if (!dateStr) return 'New';
  const date = moment(new Date(`${dateStr} UTC`));
  if (moment().diff(date, 'days') >= 1) {
    return `${date.fromNow()}`; // '2 days ago' etc.
  }
  return `${date.calendar().split(' ')[0]}`; // 'Today', 'yesterday', 'tomorrow'
};

const calcDaysAgo = (dateStr, utc = false) => {
  const date = utc ? moment.utc(dateStr) : moment(dateStr);
  return moment().diff(date, 'days');
};

const formatDuration = (mins) => {
  if (mins === undefined || mins === null || isNaN(mins)) {
    return '-';
  }
  if (mins < 121) {
    return `${mins}m`;
  }
  if (mins < 1441) {
    const hours = (mins / 60).toFixed(0);
    return `${hours}h`;
  }

  const minsPerDay = 60 * 24;
  const days = (mins / minsPerDay).toFixed(0);
  return `${days}d`;
};

export {
  formatDate, ago, calcDaysAgo, formatDuration,
};
